import delay from './delay';
import { delayActionBuilder } from './utils';

export default delay;
export { delayActionBuilder };
